const assetFiles = {
    image: {
        user: require('utils/assetFiles/image/user.png'),
        ensightfulLogo: require('utils/assetFiles/image/ensightful_logo.png'),
        projects: require('utils/assetFiles/image/projects.png'),
        inProgress: require('utils/assetFiles/image/in_progress.png'),
        overdue: require('utils/assetFiles/image/overdue.png'),
        completed: require('utils/assetFiles/image/completed.png'),
        loginBackgroundLeft: require('utils/assetFiles/image/login_background_left.png'),
        loginBackgroundRight: require('utils/assetFiles/image/login_background_right.png'),
        warningIcon: require('utils/assetFiles/image/Warning.png'),
        woman1: require('utils/assetFiles/image/woman1.svg'),
        woman2: require('utils/assetFiles/image/woman2.svg'),
        woman3: require('utils/assetFiles/image/woman3.svg'),
        man1: require('utils/assetFiles/image/man1.svg'),
        man2: require('utils/assetFiles/image/man2.svg'),
        man3: require('utils/assetFiles/image/man3.svg'),
        disconnectIcon: require('utils/assetFiles/image/Disconnect.svg'),
        nogroups: require('utils/assetFiles/image/nogroups.svg'),
        csv_graphic: require('utils/assetFiles/image/csv_graphic.png'),
        through_ensightful_graphic: require('utils/assetFiles/image/through_ensightful_graphic.png'),
        canvas_graphic: require('utils/assetFiles/image/canvas_graphic.png'),
        people: require('utils/assetFiles/image/people.svg'),
    },
};

export default assetFiles;
